import React from 'react'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'
export const PrevArrow = props => {
  return (
    <div
      onClick={() => {
        props.onClick()
        if (props.shouldSendGaEvent) {
          triggerCustomGaEvent(
            `sailingPreview-${props.gaText}`,
            true
          )
        }
      }}
      className={`slick-arrow slick-prev ${
        !props.currentSlide && !props.isInfinite ? 'hide' : ''
      } ${props.large ? 'large' : ''}`}
    >
      <svg viewBox="0 0 21 21" fill="none">
        <path
          d="M11.7002 19.3721L3.0183 10.684L11.7084 2.00005"
          stroke="#fff"
          strokeWidth="3"
        />
      </svg>
    </div>
  )
}

export const NextArrow = props => {
  const lastSlideShowing =
    !props.isInfinite &&
    props.slideCount <= props.currentSlide + props.numberOfSlidesToShow
  return (
    <div
      onClick={() => {
        props.onClick()
        if (props.shouldSendGaEvent) {
          triggerCustomGaEvent(`sailingPreview-${props.gaText}`, true)
        }
      }}
      className={`slick-arrow slick-next ${lastSlideShowing ? 'hide' : ''} ${
        props.large ? 'large' : ''
      }`}
    >
      <svg viewBox="0 0 21 21" fill="none">
        <path
          d="M8.72363 2.0127L17.3936 10.7127L8.69149 19.3847"
          stroke="#fff"
          strokeWidth="3"
        />
      </svg>
    </div>
  )
}
